module.exports = __webpack_public_path__ + "static/media/TipJarBackground.cb104f0a.png";